import React from 'react';
import './Login.css';
import FormLogin from '../../components/login/form_login';

function Login() {
  return (
    <div className='page-container login'>
      <div className='login-container'>
        <FormLogin />
      </div>
    </div>
  );
}

export default Login;